import { TranslatedText } from "@/components/common/text/TranslatedText";
import React from "react";
import { cn } from "@/utils/css";

export const NoData = ({ text, className }) => {
    return (
        <div className={cn("text-cm-text-primary text-sm", className)}>
            <TranslatedText>{text || "No data for this selection"}</TranslatedText>
        </div>
    );
};
